// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenuButton-cls1___5d5d532ec803018cc77","cls2":"AccountMenuButton-cls2__edc0296fb1848c3a7115 AccountMenuButton-cls1___5d5d532ec803018cc77"};